import landingImage from '../../img/landing1.jpg';
import breakpoints from '../../util/css/media';
import config from '../../util/js/config';

const imageOverlayTop = config.navbar === "2" ? '40vh': '35vh';

export default {
    imageDiv: {
        height: '80vh',
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(' + landingImage + ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center bottom'
    },
    imageOverlay: {
        width: '90%',
        position: 'absolute',
        top: imageOverlayTop,
        left: '50vw',
        color: 'white',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        fontSize: '3em'
    },
    h1Text: {
        ['@media (min-width: ' + breakpoints.medium + 'px)']: {
            fontSize: '2em' 
        }
    },
    h2Text: {
        ['@media (min-width: ' + breakpoints.medium + 'px)']: {
            fontSize: '0.75em' 
        }
    },
    ctaButton: {
        marginTop: 50,
        backgroundColor: 'transparent',
        borderRadius: 0,
        borderWidth: 2,
        color: 'white',
        padding: '10px 20px'
    }
}


// WEBPACK FOOTER //
// ./src/components/ImageJumbotron/ImageJumbotronStyle.js